<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/scheduler_jobs" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("admin.label.Scheduler Jobs") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full md:w-full lg:w-full">
                <ul class="horizontal-sm-btn flex mb-2 float-right">
                  <li>
                    <div
                      class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                    >
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        class="truncate"
                        @click="editJobsPopup = true"
                        size="small"
                        >{{ $t("admin.label.Edit") }}</vs-button
                      >
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="truncate"
                        size="small"
                        type="border"
                        @click="getJobParam"
                        >{{ $t("admin.label.Edit Jobs Parameters") }}</vs-button
                      >
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-bar-chart-2"
                        class="truncate"
                        size="small"
                        type="border"
                        @click="$router.push(`/view_scheduler_job/${jobId}`)"
                        >{{ $t("admin.label.Job History") }}</vs-button
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row">
              <div class="w-full">
                <div class="block overflow-x-auto">
                  <table class="table w-full table-bordered table-striped">
                    <tr>
                      <td>
                        <b>{{ $t("admin.label.Job Name") }}</b>
                      </td>
                      <td>{{ jobDetail.displayName }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("admin.label.Cron Expression") }}</b>
                      </td>
                      <td>{{ jobDetail.cronExpression }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("admin.label.Is Active Job?") }}</b>
                      </td>
                      <td>{{ jobDetail.active }}</td>
                    </tr>
                    <tr>
                      <td class="border-none">
                        <b>{{ $t("admin.label.Follow") }}</b>
                      </td>
                      <td class="border-none">
                        <a href="http://www.cronmaker.com/"
                          >Click Here To Generate Cron Expression</a
                        >
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Edit Scheduler Job')"
        :active.sync="editJobsPopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full mb-2">
                <vs-input
                  :label="$t('admin.label.Job Name')"
                  type="text"
                  v-model="jobs.displayName"
                  class="w-full font-semibold"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full mt-2 mb-2">
              <vs-input
                :label="$t('admin.label.Cron Expression')"
                type="text"
                v-model="jobs.cronExpression"
                class="w-full font-semibold"
              />
            </div>
            <div class="vx-col sm:w-full w-full mt-2 mb-2">
              <vs-input
                :label="$t('admin.label.Cron Description')"
                type="text"
                v-model="jobs.cronDescription"
                class="w-full font-semibold"
              />
            </div>
          </div>

          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button @click="updateJob" class="footerButton-next" style="top: 0px">{{
                $t("admin.label.Save")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Edit Jobs Parameters')"
        :active.sync="jobsParameterPopup"
        class="popup-close mid-popup"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div
              v-if="jobparam && jobparam.NGBPramList && jobparam.NGBPramList.length > 0"
            >
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div
                  class="vx-col sm:w-full w-full m-2 -mb-4"
                  v-for="(item, index) in jobparam.NGBPramList"
                >
                  <div class="dropdown-with-label" v-if="item.paramType === 'COMBO'">
                    <small class="date-label">{{ item.paramName }} </small>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="item.paramName"
                      :key="resetKey"
                    >
                      <v-select
                        label="batchName"
                        v-model="item.paramValue"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :options="jobParameters.queryData"
                        :reduce="(obj) => obj.batchName"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-100 mb-2"
                        style="width: 100%"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="dropdown-with-label" v-if="item.paramType === 'DATE'">
                    <small class="date-label">{{ item.paramName }}</small>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="item.paramName"
                      :key="resetKey"
                    >
                      <datepicker
                      :placeholder="$t('placeholder.label.SelectDate')"
                        v-model="item.paramValue"
                        class="mt-1 font-semibold"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div
                    v-if="item.paramType === 'TEXT'"
                    class="vx-col sm:w-full w-full m-2"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="item.paramName"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="item.paramName"
                        type="text"
                        v-model="item.paramValue"
                        class="w-full mb-2 font-semibold"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="vx-col sm:w-full w-full my-5"
                    v-if="item.paramType === 'DATE'"
                  >
                    <vs-checkbox
                      class="mt-3 font-semibold"
                      :value="item.isDynamicRaw === 'Y'"
                      @change="item.isDynamicRaw = $event ? 'Y' : 'N'"
                      >{{ $t("admin.label.Is Dynamic") }}</vs-checkbox
                    >
                  </div>
                </div>
              </div>
              <div class="vx-col w-full flex justify-center mt-3">
                <span class="ml-4 mr-1">
                  <vs-button type="border" @click="jobsParameterPopup = false">{{
                    $t("admin.label.Cancel")
                  }}</vs-button>
                </span>
                <span class="ml-1 mr-2">
                  <vs-button @click="updateJobParam">{{
                    $t("admin.label.Submit")
                  }}</vs-button>
                </span>
              </div>
            </div>
            <div class="text-center" v-else>No Data Available.</div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  data() {
    return {
      jobId: "",
      editJobsPopup: false,
      jobsParameterPopup: false,
      editJobsPopup: false,
      jobsParameterPopup: false,
      bulkUploadsPopup: false,
      selectedjobs: [],
      job: {
        displayName: "",
        cronExpression: "",
        cronDescription: "",
      },
      jobparam: {
        batchName: "",
      },
      resetKey: 0,
      jobParm: {},
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    jobDetail() {
      return this.$store.getters["admin/getJobDetail"];
    },
    ...mapState({
      jobParameters: (state) => state.admin.jobParameters,
      scheduler: (state) => state.admin.scheduler,
      jobs: (state) => state.admin.jobDetail,
    }),
  },
  methods: {
    async test(job) {
      let payload = {
        cronExpression: job.cronExpression,
        displayName: job.displayName,
        active: job.active,
      };
      try {
        await this.$store.dispatch("admin/updateJobAction", {
          id: job.jobId,
          data: payload,
        });
        this.getSchedulerJob();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateScheduler(status) {
      await this.$store.dispatch("admin/updateScheduler", status);
      this.getSchedulerJob();
    },
    async updateJob() {
      try {
        await this.$store.dispatch("admin/updateJobAction", {
          id: this.jobId,
          data: this.job,
        });
        this.editJobsPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Jobs Updated successfully!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something went wrong",
          type: "warning",
        });
      }
    },
    async getJob() {
      try {
        await this.$store.dispatch("admin/setJobDetail", this.jobId);
        this.job.cronDescription = this.jobs.cronDescription;
        this.job.cronExpression = this.jobs.cronExpression;
        this.job.displayName = this.jobs.displayName;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getJobParam() {
      this.jobsParameterPopup = true;
      this.jobparam = {};
      let id = this.jobId;
      try {
        await this.$store.dispatch("admin/getJobParameters", id);
        this.jobparam = { ...this.jobParameters };
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateJobParam() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;
      const payload = {
        jobParameters: this.jobparam.NGBPramList,
      };

      for (let item of payload.jobParameters) {
        if (item.paramType === "DATE") {
          item.paramValue = moment(item.paramValue).format("DD MMMM YYYY");
        }
      }
      try {
        await this.$store.dispatch("admin/updateJobParameterAction", {
          id: this.jobId,
          data: payload,
        });
        this.jobsParameterPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "JobParams updated successfully!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something went wrong",
          type: "warning",
        });
      }
    },
  },

  mounted() {
    this.jobId = this.$route.params.id;
    this.getJob();
  },
  watch: {
    editJobsPopup(newValue) {
      if (newValue) {
        this.getJob();
      }
    },
    jobsParameterPopup(newValue) {
      if (newValue) {
        this.getJobParam();
      }
    },
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
